import { $cms } from "@/utils/https.js";

export function getWwwCount(params) {
    return $cms().get(`/api/cms/www/count`, { params });
}

export function getBillCount(params) {
    return $cms().get(`/api/cms/manage/mall/handmade_bill/count`, { params });
}
